import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Card } from '@factorialco/f0-react'
import { Building, People, Timer } from '@factorialco/f0-react/icons/app'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useDateBookingContext } from 'modules/space_control/components/dateBookingContext'
import { useWorkSpaceUI } from 'modules/space_control/hooks/useWorkSpaceUI'
import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

interface Props {
  workSpace: WorkSpaceWithBookingNode
}

const WorkSpaceCard = ({ workSpace }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const spaceControl = useDateBookingContext()
  const onClickAddBooking = () => {
    track(trackingEvents.spaceControl.bookings.addBooking, {
      type_space: workSpace.workSpaceTypeName,
      capacity: workSpace.originalCapacity,
    })
    navigate(
      navigation.spaceControl.overview.booking.fullPath({
        date: dateToString(spaceControl.date, 'backend'),
        workSpaceId: workSpace.workSpaceId ?? '',
      })
    )
  }

  const spaceUI = useWorkSpaceUI(workSpace.workSpaceTypeValue)
  const cardImage = workSpace.images?.[0]?.url || spaceUI.placeholder

  return (
    <Box
      role="listitem"
      aria-label={workSpace.workSpaceName}
      {...(workSpace.isFull ? { style: { opacity: '0.5' } } : {})}
    >
      <F0Card
        avatar={{ type: 'icon', icon: spaceUI.icon }}
        description={workSpace.workSpaceDescription || ''}
        image={cardImage}
        title={workSpace.workSpaceName}
        aria-label={workSpace.workSpaceName}
        metadata={[
          {
            icon: Building,
            property: {
              type: 'text',
              value: workSpace.workSpaceTypeName,
            },
          },
          {
            icon: People,
            property: {
              type: 'text',
              value: i18n.tp('settings.locations.location.work_spaces.capacity_count', {
                count: workSpace.originalCapacity || 0,
              }),
            },
          },
          {
            icon: Timer,
            property: {
              type: 'status',
              value: {
                label: workSpace.isFull
                  ? i18n.t('space_control.overview.is_full')
                  : i18n.t('settings.locations.location.work_spaces.available'),
                status: workSpace.isFull ? 'critical' : 'positive',
              },
            },
          },
        ]}
        onClick={onClickAddBooking}
      />
    </Box>
  )
}

export default observer(WorkSpaceCard)
